import React from 'react';
import { useDepositBonusContext } from 'components/ClientProfile/Payment/Deposit/DepositBonusContext';

import PropTypes from 'prop-types';
import PaymentMethodItem from 'components/ClientProfile/Payment/Deposit/PaymentMethodItem';

const DepositListItem = ({ to, payment, methodAsLink }) => {
  const { depositBonuses } = useDepositBonusContext();

  return (
    <PaymentMethodItem
      to={to}
      paymentMethod={payment}
      depositBonuses={depositBonuses}
      methodAsLink={methodAsLink}
    />
  );
};

DepositListItem.propTypes = {
  to: PropTypes.string,
  payment: PropTypes.object.isRequired,
};

export default DepositListItem;
